module.exports = __webpack_public_path__ + "img/loading.1fc6213d.svg";